module.exports = __webpack_public_path__ + "img/service_zhuanli.26524758.jpg";